import { Link } from 'react-router-dom';
import { Mic } from 'lucide-react';
import { CATEGORIES } from '../lib/categories';
import { openVoiceOrder } from '../components/BottomNav';

export default function Categories() {
  return (
    <div className="max-w-3xl mx-auto px-4 md:px-6 py-6" data-testid="categories-page">
      <div className="text-[10px] uppercase tracking-[0.2em] font-black text-ink/60">Sab kuch, apne gaon mein</div>
      <h1 className="font-heading font-black text-3xl">All categories</h1>
      <div className="mt-4 grid grid-cols-2 sm:grid-cols-3 gap-3">
        {CATEGORIES.map(({ id, label, hi, Icon, bg, fg }) => (
          <Link key={id} to={`/stores?category=${id}`} data-testid={`categories-tile-${id}`}
            className="rounded-2xl p-4 min-h-[110px] flex flex-col justify-between border-2 border-transparent hover:border-ink/30 active:scale-95 transition-transform"
            style={{ backgroundColor: bg }}>
            <Icon className="w-8 h-8" style={{ color: fg }}/>
            <div>
              <div className="font-black uppercase tracking-wide text-sm" style={{ color: fg }}>{label}</div>
              <div className="text-xs font-semibold opacity-70" style={{ color: fg }}>{hi}</div>
            </div>
          </Link>
        ))}
      </div>
      <button data-testid="categories-voice-btn" onClick={openVoiceOrder}
        className="mt-6 w-full rounded-2xl border-2 border-[#1B5E20] text-[#1B5E20] font-black uppercase tracking-wider text-sm h-14 inline-flex items-center justify-center gap-2">
        <Mic className="w-5 h-5"/>Can&apos;t find it? Just say it
      </button>
    </div>
  );
}
